import { render, staticRenderFns } from "./lectures.vue?vue&type=template&id=6964a91a&scoped=true"
import script from "./lectures.vue?vue&type=script&lang=js"
export * from "./lectures.vue?vue&type=script&lang=js"
import style0 from "./lectures.vue?vue&type=style&index=0&id=6964a91a&prod&scoped=true&lang=css"
import style1 from "./lectures.vue?vue&type=style&index=1&id=6964a91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964a91a",
  null
  
)

export default component.exports